// extracted by mini-css-extract-plugin
export default {"back":"CheckoutPage_back__V2k5O","btn_prev_2":"CheckoutPage_btn_prev_2__j0+lc"};